import React from 'react';
import { Calendar, ChevronRight } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * TonightCardWidget - Shows tonight's planned dinner
 * Priority 1: Most urgent decision of the day
 */
export default function TonightCardWidget({ 
  meals = [], 
  weekStart,
  onNavigate 
}) {
  // Find tonight's meal
  const today = new Date();
  const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const todayName = dayNames[today.getDay()];
  
  const tonightsMeal = meals.find(m => m.day === todayName && !m.skipped);
  const isSkipped = meals.find(m => m.day === todayName)?.skipped;
  
  // Determine display content
  let statusText = "No dinner planned";
  let statusColor = ABLE_COLORS.textMuted;
  let recipeName = null;
  
  if (tonightsMeal?.recipe) {
    statusText = "Tonight";
    statusColor = '#059669'; // Green
    recipeName = tonightsMeal.recipe.name;
  } else if (isSkipped) {
    statusText = "Skipped today";
    statusColor = ABLE_COLORS.textMuted;
  }

  return (
    <button
      onClick={() => onNavigate && onNavigate('mealplan')}
      style={{
        width: '100%',
        padding: '20px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'all 0.15s ease',
        textAlign: 'left',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: recipeName ? '#ECFDF5' : '#F3F4F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Calendar size={20} color={recipeName ? '#059669' : ABLE_COLORS.textMuted} />
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: ABLE_COLORS.textPrimary,
          marginBottom: '4px',
        }}>
          {recipeName || "Plan dinner →"}
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: 400,
          color: statusColor,
        }}>
          {statusText}
        </div>
      </div>
      
      {/* Arrow */}
      <ChevronRight size={18} color={ABLE_COLORS.textMuted} style={{ flexShrink: 0 }} />
    </button>
  );
}
